import './create-operation-page.scss';
import PageHeader from 'modules/page-header';
import { useHistory } from 'react-router';
import { useCallback, useState } from 'react';
import PageCard from 'containers/PageCard';
import { IconBtn, UiSelect } from '@ru-digital-assets/ui-component';
import { OptionType } from '@ru-digital-assets/ui-component/dist/stories/ui/ui-select/ui-select';
import { FileInput } from 'components';
import UiInput from 'modules/ui/ui-input/ui-input';
import AppCheckbox from 'modules/app-checkbox/app-checkbox';

enum ActType {
  COURTS_DECISION = 'COURTS_DECISION',
  ROSFINMONITORINGS_DECISION = 'ROSFINMONITORINGS_DECISION',
  OTHER = 'OTHER',
}

enum DecisionType {
  WITHDRAWAL = 'WITHDRAWAL',
  FREEZING = 'FREEZING',
  TRANSFER = 'TRANSFER',
  REDDEM = 'REDDEM',
  CANCEL_REDDEM = 'CANCEL_REDDEM',
  OTHER = 'OTHER',
}

export default function CreateOperationPage() {
  const history = useHistory();
  const [actType, setActType] = useState<ActType>();
  const [decisionType, setDecisionType] = useState<DecisionType>();
  const [actFile, setActFile] = useState<File>();
  const [personNotRegistered, setPersonNotRegistered] = useState(false);

  console.log(actFile);
  console.log('actType', actType);
  console.log('decisionType', decisionType);

  const onClose = useCallback(() => history.push('/history'), []);

  const isPersonNotRegisteredBenefit =
    decisionType === DecisionType.TRANSFER ||
    (actType === ActType.OTHER && decisionType === DecisionType.OTHER);

  return (
    <div className="create-operation-page">
      <PageHeader
        items={[
          { link: '/history', title: 'Операции' },
          { link: '', title: 'Исполнение актов органов власти' },
        ]}
        iconType="history"
        isHideBalanceInformer
      />
      <PageCard
        title="Инициация исполнения акта органов власти"
        onClose={onClose}
        minHeight="calc(100vh - 102px)"
        main={
          <div className="create-operation-page__main">
            <div className="create-operation-page__form">
              <p className="p p_bold mb_24">Данные по акту</p>
              <p className="p p_font-size_14 mb_8">Выберите тип акта</p>
              <div className="mb_16">
                <UiSelect
                  placeholder="Выберите из списка"
                  options={[
                    {
                      label: 'Решение суда',
                      value: ActType.COURTS_DECISION,
                    },
                    {
                      label: 'Решение Росфинмониторинга',
                      value: ActType.ROSFINMONITORINGS_DECISION,
                    },
                    {
                      label: 'Другое',
                      value: ActType.OTHER,
                    },
                  ]}
                  onChange={(selected) => {
                    if (selected) {
                      setActType((selected as OptionType).value);
                    }
                  }}
                />
                {actType === ActType.OTHER && (
                  <div className="mt_16">
                    <UiInput
                      placeholder="Укажите другой тип акта"
                      onChange={() => {}}
                    />
                  </div>
                )}
              </div>
              <p className="p p_font-size_14 mb_8">Выберите тип решения</p>
              <div className="mb_24">
                <UiSelect
                  placeholder="Выберите из списка"
                  options={[
                    {
                      label: 'Изъятие средств на основании акта',
                      value: DecisionType.WITHDRAWAL,
                    },
                    {
                      label: 'Заморозка средств',
                      value: DecisionType.FREEZING,
                    },
                    {
                      label: 'Перечисление средств в пользу другого лица',
                      value: DecisionType.TRANSFER,
                    },
                    {
                      label: 'Погашение',
                      value: DecisionType.REDDEM,
                    },
                    {
                      label: 'Отмена погашения',
                      value: DecisionType.CANCEL_REDDEM,
                    },
                    {
                      label: 'Другое',
                      value: DecisionType.OTHER,
                    },
                  ]}
                  onChange={(selected) => {
                    if (selected) {
                      setDecisionType((selected as OptionType).value);
                    }
                  }}
                />
                {decisionType === DecisionType.OTHER && (
                  <div className="mt_16">
                    <UiInput
                      placeholder="Укажите другой тип решения"
                      onChange={() => {}}
                    />
                  </div>
                )}
              </div>
              <div className="mb_32">
                <FileInput
                  label="Загрузите файл акта"
                  onFileChange={(file) => setActFile(file)}
                />
              </div>
              <p className="p p_bold mb_24">Данные по токену</p>
              {decisionType !== DecisionType.TRANSFER && (
                <>
                  <p className="p p_font-size_14 mb_8">
                    {decisionType === DecisionType.WITHDRAWAL
                      ? 'Укажите компанию-эмитента'
                      : decisionType === DecisionType.REDDEM
                      ? 'Укажите компанию / адрес погашения'
                      : 'Укажите компанию / адрес списания'}
                  </p>
                  <div className="mb_16">
                    <UiSelect
                      placeholder="Компания / адрес"
                      options={[]}
                      onChange={(selected) => {
                        if (selected) {
                        }
                      }}
                    />
                  </div>
                </>
              )}
              {decisionType !== DecisionType.WITHDRAWAL &&
                decisionType !== DecisionType.REDDEM && (
                  <>
                    <p className="p p_font-size_14 mb_8">
                      Укажите компанию / адрес зачисления
                    </p>
                    <div className="mb_16">
                      <UiSelect
                        placeholder="Компания / адрес"
                        disabled={
                          isPersonNotRegisteredBenefit && personNotRegistered
                        }
                        options={[]}
                        onChange={(selected) => {
                          if (selected) {
                          }
                        }}
                      />
                      {isPersonNotRegisteredBenefit ? (
                        <>
                          <div className="mt_8">
                            <AppCheckbox
                              sm
                              checked={personNotRegistered}
                              onChangeValue={(value) =>
                                setPersonNotRegistered(value)
                              }
                              title="Отчуждение в пользу лица, не зарегистрированного на платформе"
                            />
                          </div>
                          {personNotRegistered && (
                            <div className="mt_16">
                              <UiInput
                                placeholder="Укажите данные лица, в пользу которого отчуждаются средства"
                                onChange={() => {}}
                              />
                            </div>
                          )}
                        </>
                      ) : null}
                    </div>
                  </>
                )}
              <p className="p p_font-size_14 mb_8">Выберите токен</p>
              <div className="mb_16">
                <UiSelect
                  placeholder="Выберите из списка"
                  options={[]}
                  onChange={(selected) => {
                    if (selected) {
                    }
                  }}
                />
              </div>
              {decisionType !== DecisionType.WITHDRAWAL && (
                <>
                  <p className="p p_font-size_14 mb_8">
                    Укажите количество токенов
                  </p>
                  <div className="create-operation-page__tokens-count">
                    <UiInput
                      placeholder="Количество токенов"
                      rightText="шт"
                      currency
                      integerCurrency
                      onChange={() => {}}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        }
        footer={
          <div className="create-operation-page__footer">
            <button className="button button_delete" onClick={onClose}>
              Отмена
            </button>
            <IconBtn title="Создать операцию" />
          </div>
        }
      />
    </div>
  );
}
